import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-557141b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trigger-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trigger-background" }, null, -1))
const _hoisted_3 = { class: "trigger" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round icon" }, "textsms", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Handle = _resolveComponent("Handle")!
  const _component_flow_node_wrapper = _resolveComponent("flow-node-wrapper")!

  return (_openBlock(), _createBlock(_component_flow_node_wrapper, {
    name: _ctx.data.name || '',
    description: _ctx.data.description || ''
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Handle, {
            class: "handle source-handle",
            type: "source",
            position: "right"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["name", "description"]))
}